import ExcelJS from "exceljs";
import {saveAs} from 'file-saver';
import Vue from "vue";

class ExportAttendanceExcel {
    // --- CẤU HÌNH STATICS (Tối ưu tài nguyên & bộ nhớ bộ cài) ---
    static FONTS = {
        title: {name: 'Arial', size: 16, bold: true, color: {argb: 'C9211E'}},
        header: {name: 'Arial', size: 10, bold: true, color: {argb: '000000'}},
        body: {name: 'Arial', size: 10},
        info: {name: 'Arial', size: 11, bold: true},
        total: {name: 'Arial', size: 10, bold: true, color: {argb: '000000'}},
        legend: {name: 'Arial', size: 10, italic: true, bold: true, color: {argb: '595959'}}
    };

    static BORDERS = {
        thin: {
            top: {style: 'thin', color: {argb: '000000'}},
            left: {style: 'thin', color: {argb: '000000'}},
            bottom: {style: 'thin', color: {argb: '000000'}},
            right: {style: 'thin', color: {argb: '000000'}}
        }
    };

    static ALIGNMENTS = {
        center: {horizontal: 'center', vertical: 'middle'},
        left: {horizontal: 'left', vertical: 'middle'},
        leftWrap: {horizontal: 'left', vertical: 'middle', wrapText: true},
        headerWrap: {horizontal: 'center', vertical: 'middle', wrapText: true}
    };

    static COLORS = {
        attendance: "AFD095",
        eat: "B4C7DC",
        header: "FFFFA6",
        note: "DDDDDD",
        total: "FFB66C",
        date: "DEE6EF"
    };

    // Định nghĩa cấu hình cột cố định cho các loại bảng
    static CONFIGS = {
        DETAIL: {
            widths: [10, 30, 16, 16, 16, 12, 12, 18, 18, 10, 10, 10, 10, 40],
            getHeaders: (worksheet) => [
                {cell: 'A5', val: 'STT', merge: 'A5:A6', fgColor: ExportAttendanceExcel.COLORS.header},
                {
                    cell: 'B5',
                    val: worksheet.name.includes('-') ? 'Ngày' : 'Họ và tên',
                    merge: 'B5:B6',
                    fgColor: ExportAttendanceExcel.COLORS.header
                },
                {cell: 'C5', val: 'Điểm danh', merge: 'C5:I5', fgColor: ExportAttendanceExcel.COLORS.attendance},
                {cell: 'C6', val: 'Đi học', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'D6', val: 'Có phép', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'E6', val: 'Không phép', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'F6', val: 'Giờ đến', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'G6', val: 'Giờ về', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'H6', val: 'Đi muộn (phút)', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'I6', val: 'Đón muộn (phút)', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'J5', val: 'Ăn', merge: 'J5:M5', fgColor: ExportAttendanceExcel.COLORS.eat},
                {cell: 'J6', val: 'Sáng', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'K6', val: 'Chính', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'L6', val: 'Phụ', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'M6', val: 'Tối', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'N5', val: 'Ghi chú', merge: 'N5:N6', fgColor: ExportAttendanceExcel.COLORS.note}
            ]
        },
        GENERAL: {
            widths: [10, 30, 16, 16, 16, 18, 18, 10, 10, 10, 10],
            getHeaders: () => [
                {cell: 'A5', val: 'STT', merge: 'A5:A6', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'B5', val: 'Họ và tên', merge: 'B5:B6', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'C5', val: 'Điểm danh', merge: 'C5:G5', fgColor: ExportAttendanceExcel.COLORS.attendance},
                {cell: 'C6', val: 'Đi học', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'D6', val: 'Có phép', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'E6', val: 'Không phép', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'F6', val: 'Đi muộn (buổi)', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'G6', val: 'Đón muộn (buổi)', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'H5', val: 'Ăn', merge: 'H5:K5', fgColor: ExportAttendanceExcel.COLORS.eat},
                {cell: 'H6', val: 'Sáng', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'I6', val: 'Chính', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'J6', val: 'Phụ', fgColor: ExportAttendanceExcel.COLORS.header},
                {cell: 'K6', val: 'Tối', fgColor: ExportAttendanceExcel.COLORS.header}
            ]
        }
    };

    /**
     * Hàm dùng chung khởi tạo cấu trúc nền tảng cho một Worksheet (Hàng 1 -> 6)
     * @private
     */
    _buildBaseWorksheet(worksheet, titleText, schoolName, targetName, dateText, configType, type) {
        worksheet.properties.defaultRowHeight = 22;
        const config = ExportAttendanceExcel.CONFIGS[configType];

        // 1. Cấu hình độ rộng cột
        config.widths.forEach((width, index) => {
            worksheet.getColumn(index + 1).width = width;
        });

        // 2. Điền thông tin tiêu đề chung (Hàng 1 -> 4)
        const infoRows = [
            {cell: 'A1', val: titleText, font: ExportAttendanceExcel.FONTS.title, height: 30},
            {cell: 'A2', val: `Trường: ${schoolName}`, font: ExportAttendanceExcel.FONTS.info},
            {
                cell: 'A3',
                val: `${type === 'group' ? 'Nhóm' : 'Lớp'}: ${targetName}`,
                font: ExportAttendanceExcel.FONTS.info
            },
            {cell: 'A4', val: `Ngày: ${dateText}`, font: ExportAttendanceExcel.FONTS.info}
        ];

        infoRows.forEach((item, idx) => {
            worksheet.mergeCells(`A${idx + 1}:C${idx + 1}`);
            const cell = worksheet.getCell(item.cell);
            cell.value = item.val;
            cell.font = item.font;
            cell.alignment = {vertical: 'middle'};
            if (item.height) worksheet.getRow(idx + 1).height = item.height;
        });

        // 3. Xây dựng cấu trúc nhóm cột Header nâng cao (Hàng 5 & 6)
        const headers = config.getHeaders(worksheet);
        headers.forEach(h => {
            if (h.merge) worksheet.mergeCells(h.merge);
            const cell = worksheet.getCell(h.cell);
            cell.value = h.val;
            cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: h.fgColor}};
        });

        // Định dạng Fonts, Borders, Alignments vùng Header
        for (let r = 5; r <= 6; r++) {
            const row = worksheet.getRow(r);
            row.height = 25;
            row.eachCell({includeEmpty: true}, (cell) => {
                cell.font = ExportAttendanceExcel.FONTS.header;
                cell.alignment = ExportAttendanceExcel.ALIGNMENTS.headerWrap;
                cell.border = ExportAttendanceExcel.BORDERS.thin;
            });
        }
    }

    /**
     * Định nghĩa đổ màu nền dữ liệu động dựa vào vị trí cột
     * @private
     */
    _getCellFillStyle(colNumber, limitAttendance = 10, limitEat = 14) {
        if (colNumber > 2 && colNumber < limitAttendance) {
            return {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.attendance}};
        } else if (colNumber >= limitAttendance && colNumber < limitEat) {
            return {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.eat}};
        } else if (colNumber === 14 && limitEat === 14) {
            return {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.note}};
        }
        return {type: 'pattern', pattern: 'none'};
    }

    /**
     * 1. Hàm xuất file Excel Điểm Danh Ngày
     */
    exportAttendanceExcelByDay = async (schoolName, targetName, date, data, type) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Điểm danh ngày', {
            views: [{showGridLines: true, state: 'frozen', xSplit: 2, ySplit: 6}]
        });

        this._buildBaseWorksheet(worksheet, "BẢNG KÊ ĐIỂM DANH NGÀY", schoolName, targetName, date, 'DETAIL', type);

        data.forEach((student, index) => {
            const rowValues = [
                index + 1,
                student.studentName || '',
                student.attendanceStatus === 'PRESENT' ? 'X' : '',
                student.attendanceStatus === 'ABSENT_CP' ? 'X' : '',
                student.attendanceStatus === 'ABSENT_KP' ? 'X' : '',
                student.arriveTime || '',
                student.leaveTime || '',
                student.arrivingLate > 0 ? student.arrivingLate : '',
                student.latePickup > 0 ? student.latePickup : '',
                student.breakfast ? 'X' : '',
                student.mainMeal ? 'X' : '',
                student.snack ? 'X' : '',
                student.dinner ? 'X' : '',
                student.note || ''
            ];

            const row = worksheet.addRow(rowValues);
            row.height = 22;

            row.eachCell({includeEmpty: true}, (cell, colNumber) => {
                cell.font = ExportAttendanceExcel.FONTS.body;
                cell.border = ExportAttendanceExcel.BORDERS.thin;
                cell.alignment = colNumber === 2 ? ExportAttendanceExcel.ALIGNMENTS.left :
                    colNumber === 14 ? ExportAttendanceExcel.ALIGNMENTS.leftWrap : ExportAttendanceExcel.ALIGNMENTS.center;
                cell.fill = this._getCellFillStyle(colNumber);
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        saveAs(blob, `QUAN_LY_DIEM_DANH_HOC_SINH_${date.replace(/\//g, '-')}_Lop_${targetName}.xlsx`);
    };

    /**
     * 2. Hàm xuất file Excel Điểm Danh Theo Tháng (Mỗi học sinh một Sheet)
     */
    exportAttendanceExcelByMonth = async (data, type) => {
        const workbook = new ExcelJS.Workbook();
        const schoolName = data.schoolName || "";
        const targetName = type === 'group' ? data.groupName || "" : data.className || "";
        const fromDate = Vue.filter('formatDate')(data.fromDate);
        const toDate = Vue.filter('formatDate')(data.toDate);
        const dateStr = `${fromDate} - ${toDate}`;
        const value = data.data;

        value.forEach((student) => {
            const attendances = student.attendances || [];
            let sheetName = `${student.studentName} - ${student.studentId}`.replace(/[\\/*?:[\]]/g, '').substring(0, 31);

            const worksheet = workbook.addWorksheet(sheetName, {
                views: [{showGridLines: true, state: 'frozen', ySplit: 6}]
            });

            this._buildBaseWorksheet(worksheet, "BẢNG KÊ ĐIỂM DANH THEO THÁNG", schoolName, targetName, dateStr, 'DETAIL', type);

            attendances.forEach((item, index) => {
                const rowValues = [
                    index + 1,
                    item.attendanceDate ? Vue.filter('formatDate')(item.attendanceDate) : '',
                    item.attendanceStatus === 'PRESENT' ? 'X' : '',
                    item.attendanceStatus === 'ABSENT_CP' ? 'X' : '',
                    item.attendanceStatus === 'ABSENT_KP' ? 'X' : '',
                    item.arriveTime || '',
                    item.leaveTime || '',
                    item.arrivingLate > 0 ? item.arrivingLate : '',
                    item.latePickup > 0 ? item.latePickup : '',
                    item.breakfast ? 'X' : '',
                    item.mainMeal ? 'X' : '',
                    item.snack ? 'X' : '',
                    item.dinner ? 'X' : '',
                    item.note || ''
                ];

                const row = worksheet.addRow(rowValues);
                row.height = 22;

                row.eachCell({includeEmpty: true}, (cell, colNumber) => {
                    cell.font = ExportAttendanceExcel.FONTS.body;
                    cell.border = ExportAttendanceExcel.BORDERS.thin;
                    cell.alignment = colNumber === 14 ? ExportAttendanceExcel.ALIGNMENTS.leftWrap : ExportAttendanceExcel.ALIGNMENTS.center;
                    cell.fill = this._getCellFillStyle(colNumber);
                });
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        saveAs(blob, `QUAN_LY_DIEM_DANH_HOC_SINH_THEO_THANG_${new Date().toISOString().slice(0, 10)}_${type === 'group' ? 'Nhom' : 'Lop'}_${targetName}.xlsx`);
    };

    /**
     * 3. Hàm xuất file Excel tổng hợp theo khoảng ngày (Có Hàng Tổng Số Công Thức)
     */
    exportAttendanceExcelGeneral = async (data, type) => {
        const workbook = new ExcelJS.Workbook();

        data.forEach((value) => {
            const schoolName = value.schoolName || "";
            const targetName = type === 'group' ? value.groupName || "" : value.className || "";
            const fromDate = Vue.filter('formatDate')(value.fromDate);
            const toDate = Vue.filter('formatDate')(value.toDate);
            const dateStr = `${fromDate} - ${toDate}`;
            const attendanceData = value.data;

            const worksheet = workbook.addWorksheet(`${targetName}`, {
                views: [{showGridLines: true, state: 'frozen', ySplit: 6}]
            });

            this._buildBaseWorksheet(worksheet, "BẢNG TỔNG HỢP ĐIỂM DANH", schoolName, targetName, dateStr, 'GENERAL', type);

            attendanceData.forEach((student, index) => {
                const rowValues = [
                    index + 1,
                    student.fullName || '',
                    student.presentStatus > 0 ? student.presentStatus : '',
                    student.absentCpStatus > 0 ? student.absentCpStatus : '',
                    student.absentKpStatus > 0 ? student.absentKpStatus : '',
                    student.arrivingLate > 0 ? student.arrivingLate : '',
                    student.latePickup > 0 ? student.latePickup : '',
                    student.breakfast > 0 ? student.breakfast : '',
                    student.mainMeal > 0 ? student.mainMeal : '',
                    student.snack > 0 ? student.snack : '',
                    student.dinner > 0 ? student.dinner : ''
                ];

                const row = worksheet.addRow(rowValues);
                row.height = 22;

                row.eachCell({includeEmpty: true}, (cell, colNumber) => {
                    cell.font = ExportAttendanceExcel.FONTS.body;
                    cell.border = ExportAttendanceExcel.BORDERS.thin;
                    cell.alignment = colNumber === 2 ? ExportAttendanceExcel.ALIGNMENTS.left : ExportAttendanceExcel.ALIGNMENTS.center;
                    cell.fill = this._getCellFillStyle(colNumber, 8, 12);
                });
            });

            const startRow = 7;
            const endRow = worksheet.rowCount;

            const totalRow = worksheet.addRow([
                '',
                'TỔNG CỘNG:',
                {formula: `SUM(C${startRow}:C${endRow})`},
                {formula: `SUM(D${startRow}:D${endRow})`},
                {formula: `SUM(E${startRow}:E${endRow})`},
                {formula: `SUM(F${startRow}:F${endRow})`},
                {formula: `SUM(G${startRow}:G${endRow})`},
                {formula: `SUM(H${startRow}:H${endRow})`},
                {formula: `SUM(I${startRow}:I${endRow})`},
                {formula: `SUM(J${startRow}:J${endRow})`},
                {formula: `SUM(K${startRow}:K${endRow})`}
            ]);
            totalRow.height = 24;

            totalRow.eachCell({includeEmpty: true}, (cell, colNumber) => {
                if (colNumber <= 11) {
                    cell.font = ExportAttendanceExcel.FONTS.total;
                    cell.border = ExportAttendanceExcel.BORDERS.thin;
                    cell.alignment = colNumber === 2 ? ExportAttendanceExcel.ALIGNMENTS.left : ExportAttendanceExcel.ALIGNMENTS.center;
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: ExportAttendanceExcel.COLORS.total}
                    };
                }
            });
        })

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        saveAs(blob, `TONG_HOP_DIEM_DANH_${new Date().toISOString().slice(0, 10)}_${type === 'group' ? "Nhóm" : "Lớp"}.xlsx`);
    };

    /**
     * 4. [NEW ADDED] Hàm xuất file Excel Bảng tổng hợp điểm danh chi tiết chạy ngày động
     * @param {Array} data - Dạng Object chứa { schoolName, className, startDate, endDate, dates: [], students: [] }
     * @param {String} type - 2 kiểu "class" / "group"
     */
    exportAttendanceExcelDetailed = async (data, type) => {
        const workbook = new ExcelJS.Workbook();

        data.forEach((row) => {
            const schoolName = row.schoolName || "";
            const targetName = type === 'group' ? row.groupName || "" : row.className || "";
            const fromDate = Vue.filter('formatDate')(row.fromDate);
            const toDate = Vue.filter('formatDate')(row.toDate);
            const dateStr = `${fromDate} - ${toDate}`;
            const dates = row.dates;
            const value = row.students;

            const worksheet = workbook.addWorksheet(`${targetName}`, {
                views: [{showGridLines: true, state: 'frozen', xSplit: 4, ySplit: 6}]
            });

            worksheet.properties.defaultRowHeight = 22;

            // Tính toán tọa độ phân khu động
            const startDynamicCol = 5;
            const dynamicColCount = dates.length;
            const presentGroupStart = startDynamicCol + dynamicColCount;
            const absentGroupStart = presentGroupStart + 4;
            const totalColumns = absentGroupStart + 4 - 1;

            // Cấu hình độ rộng cột động linh hoạt
            for (let i = 1; i <= totalColumns; i++) {
                if (i === 1) worksheet.getColumn(i).width = 8;
                else if (i === 2) worksheet.getColumn(i).width = 25;
                else if (i === 3 || i === 4) worksheet.getColumn(i).width = 14;
                else if (i >= startDynamicCol && i < presentGroupStart) worksheet.getColumn(i).width = 12;
                else worksheet.getColumn(i).width = 10;
            }

            // Hàng 1: Tiêu đề lớn gộp toàn dải
            worksheet.mergeCells('A1:D1');
            const titleCell = worksheet.getCell('A1');
            titleCell.value = "BẢNG TỔNG HỢP ĐIỂM DANH CHI TIẾT";
            titleCell.font = ExportAttendanceExcel.FONTS.title;
            worksheet.getRow(1).height = 30;
            worksheet.getRow(1).alignment = {horizontal: 'left', vertical: 'middle'};

            // Hàng 2 & Hàng 3: Đơn vị hành chính công tác
            worksheet.mergeCells('A2:D2');
            worksheet.getCell('A2').value = `Trường: ${schoolName}`;
            worksheet.getCell('A2').font = ExportAttendanceExcel.FONTS.info;
            worksheet.getCell('A2').alignment = {horizontal: 'left', vertical: 'middle'};

            worksheet.mergeCells('A3:D3');
            worksheet.getCell('A3').value = `${type === 'group' ? 'Nhóm' : "Lớp"}: ${targetName}`;
            worksheet.getCell('A3').font = ExportAttendanceExcel.FONTS.info;
            worksheet.getCell('A3').alignment = {horizontal: 'left', vertical: 'middle'};

            // Hàng 4: Khoảng ngày bên trái & Khối ký hiệu chú thích dạt sang phải
            worksheet.mergeCells('A4:C4');
            worksheet.getCell('A4').value = `Ngày: ${dateStr}`;
            worksheet.getCell('A4').font = ExportAttendanceExcel.FONTS.info;
            worksheet.getCell('A4').alignment = {horizontal: 'left', vertical: 'middle'};

            worksheet.mergeCells(4, startDynamicCol, 4, totalColumns); // startDynamicCol chính là 5 (Cột E)
            const legendCell = worksheet.getCell(4, startDynamicCol);
            legendCell.value = "Kí hiệu :  1 - Đi học | P - Có phép | K - Không phép | x - Chưa điểm danh";
            legendCell.font = ExportAttendanceExcel.FONTS.legend;
            legendCell.alignment = {horizontal: 'left', vertical: 'middle'};

            // Xây dựng Cấu trúc Header Đa tầng (Hàng 5 & Hàng 6)
            // 1. Nhóm cột cố định bên trái (STT, Họ tên, Ngày sinh, Trạng thái)
            const staticHeaders = ['STT', 'Họ và tên', 'Ngày sinh', 'Trạng thái'];
            staticHeaders.forEach((label, idx) => {
                const colNum = idx + 1;
                worksheet.mergeCells(5, colNum, 6, colNum);
                const cell = worksheet.getCell(5, colNum);
                cell.value = label;
                cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.header}};
            });

            // 2. Chạy vòng lặp render các ô Cột Ngày động
            dates.forEach((d, idx) => {
                const colNum = startDynamicCol + idx;
                worksheet.mergeCells(5, colNum, 6, colNum);
                const cell = worksheet.getCell(5, colNum);
                cell.value = `${d.dateStr} (${d.dayLabel})`;
                cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.date}};
            });

            // 3. Khối gộp tầng 1 "Đi học"
            worksheet.mergeCells(5, presentGroupStart, 5, presentGroupStart + 3);
            const pCell = worksheet.getCell(5, presentGroupStart);
            pCell.value = "Đi học";
            pCell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.attendance}};

            const subLabels = ['T2 – T6', 'T7', 'Chủ nhật', 'Tổng'];
            subLabels.forEach((label, idx) => {
                const cell = worksheet.getCell(6, presentGroupStart + idx);
                cell.value = label;
                cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.header}};
            });

            // 4. Khối gộp tầng 1 "Nghỉ học"
            worksheet.mergeCells(5, absentGroupStart, 5, absentGroupStart + 3);
            const aCell = worksheet.getCell(5, absentGroupStart);
            aCell.value = "Nghỉ học";
            aCell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.eat}};

            subLabels.forEach((label, idx) => {
                const cell = worksheet.getCell(6, absentGroupStart + idx);
                cell.value = label;
                cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: ExportAttendanceExcel.COLORS.header}};
            });

            // Đồng bộ style viền và font chữ cho Header (Hàng 5 & 6)
            for (let r = 5; r <= 6; r++) {
                worksheet.getRow(r).height = 25;
                worksheet.getRow(r).eachCell({includeEmpty: true}, cell => {
                    cell.font = ExportAttendanceExcel.FONTS.header;
                    cell.alignment = ExportAttendanceExcel.ALIGNMENTS.headerWrap;
                    cell.border = ExportAttendanceExcel.BORDERS.thin;
                });
            }

            // Đổ dữ liệu lịch sử điểm danh của học sinh (Bắt đầu từ Hàng 7)
            const startDataRow = 7;
            value.forEach((student, index) => {
                const currentRow = startDataRow + index;
                const rowValues = [];

                rowValues[1] = index + 1;
                rowValues[2] = student.nameStudent || '';
                rowValues[3] = student.dob || '';
                rowValues[4] = student.status || '';

                // Map ký hiệu điểm danh vào từng cột ngày tương ứng
                dates.forEach((d, dIdx) => {
                    rowValues[startDynamicCol + dIdx] = student.attendance[d.fullDate] || '';
                });

                // Gán dữ liệu thống kê tổng hợp của học sinh
                rowValues[presentGroupStart] = student.summary.present.t2_t6 || '';
                rowValues[presentGroupStart + 1] = student.summary.present.t7 || '';
                rowValues[presentGroupStart + 2] = student.summary.present.cn || '';

                rowValues[absentGroupStart] = student.summary.absent.t2_t6 || '';
                rowValues[absentGroupStart + 1] = student.summary.absent.t7 || '';
                rowValues[absentGroupStart + 2] = student.summary.absent.cn || '';

                const row = worksheet.addRow(rowValues);
                row.height = 22;

                // Chèn công thức SUM tự động tính tổng ngang cho cột 'Tổng' dữ liệu hàng
                const presLetterStart = worksheet.getColumn(presentGroupStart).letter;
                const presLetterEnd = worksheet.getColumn(presentGroupStart + 2).letter;
                worksheet.getCell(currentRow, presentGroupStart + 3).value = {formula: `SUM(${presLetterStart}${currentRow}:${presLetterEnd}${currentRow})`};

                const absLetterStart = worksheet.getColumn(absentGroupStart).letter;
                const absLetterEnd = worksheet.getColumn(absentGroupStart + 2).letter;
                worksheet.getCell(currentRow, absentGroupStart + 3).value = {formula: `SUM(${absLetterStart}${currentRow}:${absLetterEnd}${currentRow})`};

                row.eachCell({includeEmpty: true}, (cell, colNumber) => {
                    cell.font = ExportAttendanceExcel.FONTS.body;
                    cell.border = ExportAttendanceExcel.BORDERS.thin;
                    cell.alignment = colNumber === 2 ? ExportAttendanceExcel.ALIGNMENTS.left : ExportAttendanceExcel.ALIGNMENTS.center;

                    // --- ĐOẠN ĐƯỢC CẬP NHẬT: Tô màu dữ liệu theo phân khu cột ứng với Header ---
                    if (colNumber >= startDynamicCol && colNumber < presentGroupStart) {
                        // Cột các ngày động
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: ExportAttendanceExcel.COLORS.date}
                        };
                    } else if (colNumber >= presentGroupStart && colNumber < absentGroupStart) {
                        // Cột thuộc nhóm "Đi học"
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: ExportAttendanceExcel.COLORS.attendance}
                        };
                    } else if (colNumber >= absentGroupStart && colNumber <= totalColumns) {
                        // Cột thuộc nhóm "Nghỉ học"
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: ExportAttendanceExcel.COLORS.eat}
                        };
                    }
                });
            });

            // Vẽ 5 dòng THỐNG KÊ TỔNG HỢP cuối bảng (COUNTIF theo chiều dọc của từng cột ngày)
            const endDataRow = worksheet.rowCount;
            const summaryConfigs = [
                {label: "Tổng đi học:", criteria: "1"},
                {label: "Tổng có phép:", criteria: "P"},
                {label: "Tổng không phép:", criteria: "K"},
                {label: "Tổng chưa điểm danh:", criteria: "x"}
            ];

            summaryConfigs.forEach((config) => {
                worksheet.addRow([]); // Tạo dòng mới rỗng
                const currentSRow = worksheet.rowCount;
                worksheet.getRow(currentSRow).height = 24;

                // Gộp 4 cột đầu ghi nhãn thống kê
                worksheet.mergeCells(currentSRow, 1, currentSRow, 4);
                const labelCell = worksheet.getCell(currentSRow, 1);
                labelCell.value = config.label;
                labelCell.font = ExportAttendanceExcel.FONTS.header;
                labelCell.alignment = {horizontal: 'left', vertical: 'middle'};

                // Bắn công thức COUNTIF chạy dọc theo số ô ngày động
                for (let c = startDynamicCol; c < presentGroupStart; c++) {
                    const colLetter = worksheet.getColumn(c).letter;
                    const cell = worksheet.getCell(currentSRow, c);
                    cell.value = {formula: `COUNTIF(${colLetter}${startDataRow}:${colLetter}${endDataRow},"${config.criteria}")`};
                    cell.font = ExportAttendanceExcel.FONTS.total;
                    cell.alignment = ExportAttendanceExcel.ALIGNMENTS.center;
                }

                // Đổ màu nền Note (Xám nhẹ) toàn bộ dòng tổng kết
                for (let i = 1; i <= totalColumns; i++) {
                    const cell = worksheet.getCell(currentSRow, i);
                    cell.border = ExportAttendanceExcel.BORDERS.thin;
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: ExportAttendanceExcel.COLORS.total}
                    };
                }
            });
        })

        // Thực hiện kết xuất nhị phân và download file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        saveAs(blob, `TONG_HOP_DIEM_DANH_CHI_TIET_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };
}

export default new ExportAttendanceExcel();